<template>
  <div class="no_data" :style="{ width: width, height: height }">
    <div class="content_box" :style="{ top: top }">
      <div class="img_box">
        <img class="full_img" :src="sceneType === 'night' ? nightImg : dayImg" alt="">
      </div>
      <span>{{ $t('暂无数据') }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NoData',
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    sceneType: { // 场景类型：night:组件背景为暗色，day:组件背景为白色(默认：night)
      type: String,
      default: 'night'
    },
    top: { // 中间内容距离顶部的距离
      type: String,
      default: '50%'
    }
  },
  data () {
    return {
      nightImg: require('./../../assets/images/nightImage.png'),
      dayImg: require('./../../assets/images/dayImage.png')
    }
  }
}
</script>
<style lang="less" scoped>
.no_data{
  min-height: inherit;
  position: relative;
  .content_box{
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    .img_box{
      margin-bottom: 10px;
      width: 44px;
      height: 40px;
    }
    span{
      font-size: 12px;
      font-family: PingFangSC-Medium, "PingFang SC";
      font-weight: 500;
      color: @textColor2;
      line-height: 17px;
    }
  }
}
</style>
